import { Directive, input } from '@angular/core';

@Directive({
  selector: '[appClickLinkRedirect]',
  host: {
    '(click)': 'onHandleClickLinkRedirect()',
  },
})
export class ClickLinkRedirectDirective {
  public link = input.required<string>({ alias: 'appClickLinkRedirect' });

  protected onHandleClickLinkRedirect(): void {
    window.open(this.link(), '_blank');
  }
}
